var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogTimeGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10.668,
    height: 10.668,
    viewBox: "0 0 10.668 10.668",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "log_time",
    "data-name": "log time",
    transform: "translate(-3.371 -3.375)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3823",
    "data-name": "Path 3823",
    d: "M8.7,3.375a5.332,5.332,0,1,0,3.776,1.56A5.334,5.334,0,0,0,8.7,3.375Zm.005,9.6a4.267,4.267,0,1,1,4.267-4.267A4.267,4.267,0,0,1,8.7,12.975Z",
    fill: "#30d500"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3824",
    "data-name": "Path 3824",
    d: "M17.338,10.688h-.8v3.2l2.8,1.68.4-.656-2.4-1.423Z",
    transform: "translate(-8.362 -4.646)",
    fill: "#30d500"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogTimeGreen);
export default __webpack_public_path__ + "static/media/log_timeGreen.16c3cfb62a08924b74aee5dc4b61a088.svg";
export { ForwardRef as ReactComponent };